import i18n from "@/lib/i18n";
import React from "react";
import { UseFormReturn, FieldValues, Path } from "react-hook-form";

interface NotesFieldProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  fieldName: Path<T>;
  label?: string;
  placeholder?: string;
  rows?: number;
}

export const NotesField = <T extends FieldValues>({
  form,
  fieldName,
  placeholder = i18n.t("components.quotes.notesField.enterNotes"),
  rows = 4,
}: NotesFieldProps<T>) => {
  return (
    <div className="space-y-2">
      <textarea
        {...form.register(fieldName)}
        placeholder={placeholder}
        className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        rows={rows}
      />
      {form.formState.errors[fieldName] && (
        <p className="text-sm text-destructive">
          {String(form.formState.errors[fieldName]?.message)}
        </p>
      )}
    </div>
  );
};
